
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/institutions",
      function () {
        return require("private-next-pages/institutions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/institutions"])
      });
    }
  